module.exports = __webpack_public_path__ + "images/emoji/tophat.51ee688bb4c310b4e4e9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tophat.png
// module id = 9esn
// module chunks = 2